module.exports = __webpack_public_path__ + "static/media/CancelIcon.39ce3d0a.svg";